__turbopack_context__.v({
  "content": "lCRGiq_content",
  "drawer": "lCRGiq_drawer",
});
